<template>
  <div class="supplierAgents responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'supplierAgents', label: 'Supplier Agents' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Entities from "@/resources/Entities";
import SearchTable from "@/components/SearchTable.vue";

import { listPageHeader } from "./inputs";

export default {
  name: "supplierAgents",
  data() {
    return {
      selectedFilter: {},
      Entities,
      entity: Entities.SUPPLIERAGENT,
      listPageHeader,
    };
  },
  components: {
    PageHeader,
    SearchTable,
  },
  created: function () {
    this.setPageTitle("Supplier Agents");
  },
};
</script>
